module.exports = __webpack_public_path__ + "static/media/pbl-logo-login-contrast.4243dd34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pbl-logo-login-contrast.svg
// module id = 720
// module chunks = 0